import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminGetProducts, adminGetOrders, getCategories } from '../../api';
import './AdminLayout.css';

export default function AdminDashboard() {
  const [stats, setStats] = useState({ products: 0, categories: 0, orders: 0, revenue: 0 });
  const [recentOrders, setRecentOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      adminGetProducts(),
      getCategories(),
      adminGetOrders(),
    ]).then(([p, c, o]) => {
      const orders = o.data || [];
      const revenue = orders.reduce((s, ord) => s + (ord.total || 0), 0);
      setStats({
        products: p.data.total || 0,
        categories: c.data.length || 0,
        orders: orders.length,
        revenue,
      });
      setRecentOrders(orders.slice(0, 5));
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const STATUS_COLORS = {
    placed: 'badge-blue', confirmed: 'badge-yellow',
    shipped: 'badge-yellow', delivered: 'badge-green', cancelled: 'badge-red',
  };

  return (
    <div>
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title">Dashboard</h1>
          <p className="admin-page-sub">Welcome back — here's what's happening</p>
        </div>
      </div>

      {loading ? (
        <div className="admin-loading">Loading…</div>
      ) : (
        <>
          {/* Stat cards */}
          <div className="stat-cards">
            {[
              { label: 'Total Products', value: stats.products, icon: '📦', link: '/admin/products' },
              { label: 'Categories', value: stats.categories, icon: '🗂️', link: '/admin/categories' },
              { label: 'Orders', value: stats.orders, icon: '🛒', link: '/admin/orders' },
              { label: 'Revenue', value: `₹${stats.revenue.toLocaleString('en-IN')}`, icon: '💰', link: '/admin/orders' },
            ].map(s => (
              <Link key={s.label} to={s.link} className="stat-card" style={{ textDecoration: 'none' }}>
                <div className="stat-card-label">{s.icon} {s.label}</div>
                <div className="stat-card-value">{s.value}</div>
              </Link>
            ))}
          </div>

          {/* Quick actions */}
          <div style={{ padding: '0 28px', marginBottom: 24, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <Link to="/admin/products/new" className="btn-primary">+ Add Product</Link>
            <Link to="/admin/categories" className="btn-secondary">Manage Categories</Link>
            <Link to="/admin/orders" className="btn-secondary">View Orders</Link>
          </div>

          {/* Recent orders */}
          {recentOrders.length > 0 && (
            <div style={{ padding: '0 28px 28px' }}>
              <div className="admin-card">
                <div style={{ padding: '16px 20px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <h3 style={{ fontSize: 15, fontWeight: 700 }}>Recent Orders</h3>
                  <Link to="/admin/orders" style={{ fontSize: 13, color: '#f59e0b', textDecoration: 'none', fontWeight: 600 }}>See all →</Link>
                </div>
                <div className="admin-table-wrap">
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>Order #</th><th>Total</th><th>Payment</th><th>Status</th><th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {recentOrders.map(order => (
                        <tr key={order._id}>
                          <td><strong>{order.orderNumber}</strong></td>
                          <td>₹{order.total?.toLocaleString('en-IN')}</td>
                          <td style={{ textTransform: 'capitalize' }}>{order.paymentMethod}</td>
                          <td>
                            <span className={`badge ${STATUS_COLORS[order.orderStatus] || 'badge-gray'}`}>
                              {order.orderStatus}
                            </span>
                          </td>
                          <td style={{ color: '#9ca3af', fontSize: 13 }}>
                            {new Date(order.createdAt).toLocaleDateString('en-IN')}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
